<template>
  <div class="outer">
    <b-container>
      <div no-gutters v-for="disp in getActive" v-bind:key="disp.displayid" class="display-row">
        <div class="cool-description">
          <div class="title-div">
            <h2 class="cool-title">{{disp.title}}</h2>
            <span class="votes">Votes:&nbsp;{{disp.votes}}</span>
            <span v-if="disp.isMusical">🎵</span>
          </div>
          <img class="img-fluid" v-bind:src="disp.displayImage" alt="[picture]" />
          <br />
          {{disp.street}} {{disp.city}}, {{disp.state}}
          <a
            v-bind:href="disp.directionUrl"
          >(Directions)</a>
          <br />
          <div role="alert" class="alert alert-secondary full-description">
            {{disp.description}}
            <div class="cool-link" v-if="showCoolLink(disp)">
              {{coolLinkText(disp)}} at
              <a v-bind:href="disp.coolUrl">CoolDisplays.Net</a>
            </div>
          </div>
        </div>
        <VoteFor />
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VoteFor from "./VoteFor.vue";

export default {
  name: "Details",
  components: {
    VoteFor
  },
  methods: {
    ...mapActions(["setActive", "fetchState"]),
    showCoolLink(disp) {
      if (disp.images.length > 1) {
        return true;
      } else if (disp.videos.length > 0) {
        return true;
      }
      return false;
    },
    coolLinkText(disp) {
      let imageCnt = disp.images.length;
      let videoCnt = disp.videos.length;
      if (imageCnt > 1 && videoCnt > 0) {
        return "See more images and videos";
      }
      if (imageCnt > 1) {
        return "See more images";
      }
      if (videoCnt > 0) return "See videos";
      return "";
    }
  },
  computed: {
    ...mapGetters(["allDisplays", "getActive", "isLoaded"])
  },
  watch: {
    $route() {
      this.setActive(this.$route.params.id);
    }
  },

  created() {
    this.setActive(this.$route.params.id);
  }
};
</script>

<style scoped>
.cool-title {
  font-size: 1.8em;
  text-decoration: underline;
  color: darkred;
  display: inline;
}
.votes {
  color: green;
  font-style: italic;
  font-size: 1em;
  padding-left: 0.3em;
  vertical-align: 0.2em;
}
.full-description {
  text-align: left;
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.cool-link {
  margin-top: 1em;
  text-align: center;
}

.display-row {
  border: 2px;
  border-style: solid;
  border-radius: 25px;
  margin: 2px;
}
</style>
